<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <transition name="title">
          <div v-if="page === 1" key="list" class="title">Despesas</div>
          <div v-if="page === 2" key="info" class="title">Informações</div>
          <div v-if="page === 3" key="info" class="title">Remover despesa</div>
        </transition>
        <div @click="$router.push('/event')" class="close"><i class="fas fa-times"></i></div>
      </div>
      <transition name="page">
        <!-- Despesas -->
        <div v-if="page === 1" key="page-1">
          <form @submit.prevent class="form">
            <div style="margin-bottom: 15px">
              <div v-for="expense in expenses" :key="expense.id" class="list-form">
                <div class="form-data">{{ expense.description }}</div>
                <div class="form-actions" style="width: 100px">R$ {{ expense.value.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
                <div class="form-actions">
                  <button @click="changePage(2, expense)" class="button-form-action"><i class="fas fa-pen"></i></button>
                  <button @click="changePage(3, expense)" class="button-form-action"><i class="fas fa-times"></i></button>
                </div>
              </div>
            </div>
            <button @click="changePage(2)" class="button-form" style="margin: 0"><i class="fas fa-plus"></i><span>Nova Despesa</span></button>
          </form>
        </div>
        <!-- Informações -->
        <div v-if="page === 2" key="page-2">
          <form @submit.prevent class="form">
            <!-- Descrição -->
            <label>Descrição</label>
            <input v-model="description" type="text" placeholder="Descrição da despesa" :class="{ error : error.indexOf('description') > -1 }" />
            <div v-if="error.indexOf('description') > -1" class="hint">você esqueceu da descrição</div>
            <!-- Valor -->
            <label>Valor</label>
            <money v-model="value" :class="{ error : error.indexOf('value') > -1 }" style="max-width: 100px"></money>
            <div v-if="error.indexOf('value') > -1" class="hint">você esqueceu do valor</div>
          </form>
          <div class="actions">
            <button @click="changePage(1)" class="button-previous"><i class="fas fa-angle-left"></i><span>Voltar</span></button>
            <button @click="save" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Confirmar</span></button>
          </div>
        </div>
        <!-- Remover -->
        <div v-if="page === 3" key="page-3">
          <form @submit.prevent class="form">
            <label>Confirma exclusão da despesa?</label>
          </form>
          <div class="actions">
            <button v-if="id !== 'new'" @click="changePage(0)" class="button-previous"><i class="fas fa-angle-left"></i><span>Voltar</span></button>
            <button v-if="id !== 'new'" @click="remove" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Confirmar</span></button>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { getAll, create, update, remove } from '../api/showExpense'

export default {
  name: 'showExpense',
  props: ['showDate'],
  data () {
    return {
      loading: true,
      page: 1,
      error: [],
      expenses: [],
      id: null,
      description: null,
      value: 0
    }
  },
  async mounted () {
    try {
      this.expenses = await getAll(this.showDate)
    } catch (error) {
      logger.error(error, this)
    }
    this.loading = false
  },
  methods: {
    async changePage (page, expense = null) {
      try {
        if (this.loading) return false
        // List
        if (page === 1) {
          this.expenses = await getAll(this.showDate)
        // Create
        } else if (page === 2 && !expense) {
          this.id = null
          this.description = null
          this.value = 0
        // Update
        } else if (page === 2 && expense) {
          this.id = expense.id
          this.description = expense.description
          this.value = expense.value
        // Remove
        } else {
          this.id = expense.id
        }
        this.page = page
      } catch (error) {
        logger.error(error, this)
      }
    },
    async save () {
      if (this.loading) return false
      this.loading = true
      try {
        this.error = []
        if (this.id) {
          // Update expense
          await update(this.id, this.description, this.value)
        } else {
          // Create expense
          await create(this.showDate, this.description, this.value)
        }
        this.loading = false
        this.changePage(1)
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    async remove () {
      if (this.loading) return false
      this.loading = true
      try {
        // Remove expense
        await remove(this.id)
        this.loading = false
        this.changePage(1)
      } catch (error) {
        logger.error(error, this)
      }
      this.loading = false
    }
  }
}
</script>
